import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../../../i18n';
import MarketingLogo from './MarketingLogo';
import { AUTHOR } from './author';
import { ALL_GUIDES, FEATURED_PAGES, GUIDE_THEMES, GuideEntry, TOOL_PAGES } from './guideIndex';

// Pied de page du site vitrine : logo et signature, outils, guides par thème
// (vers /guides, qui les liste tous), articles à la une, pages légales.
const MarketingFooter: React.FC = () => {
  const t = useT();
  const column = (title: string, links: GuideEntry[]) => (
    <nav className="mk-footer-col" aria-label={t(title)}>
      <p className="mk-footer-title">{t(title)}</p>
      {links.map((l) => (
        <Link key={l.to} to={l.to}>
          {t(l.label)}
        </Link>
      ))}
    </nav>
  );
  return (
    <footer className="mk-footer">
      <div className="mk-footer-inner mk-container">
        <div className="mk-footer-cols">
          <div className="mk-footer-brand">
            <MarketingLogo />
            <span>{t('Fait avec amour pour les futurs mariés')}</span>
            <div className="mk-footer-links-row">
              <Link to="/guides" className="mk-footer-guides">
                <b>{ALL_GUIDES.length}</b> {t('guides et outils gratuits')} →
              </Link>
              <Link to={AUTHOR.path} className="mk-footer-author">
                <img src={AUTHOR.avatar} alt="" width={28} height={28} loading="lazy" />
                {t('Qui est derrière RSVP Please ?')}
              </Link>
            </div>
          </div>
          {column('Outils', TOOL_PAGES)}
          <nav className="mk-footer-col mk-footer-themes" aria-label={t('Guides par thème')}>
            <p className="mk-footer-title">{t('Guides par thème')}</p>
            {GUIDE_THEMES.map((theme) => (
              <Link key={theme.id} to={`/guides#${theme.id}`}>
                {t(theme.title)}
              </Link>
            ))}
          </nav>
          {column('À la une', FEATURED_PAGES)}
        </div>
        <nav className="mk-footer-links" aria-label={t('Informations légales')}>
          <Link to="/mentions-legales">{t('Mentions légales')}</Link>
          <Link to="/confidentialite">{t('Confidentialité')}</Link>
          <Link to="/conditions">{t('Conditions d’utilisation')}</Link>
        </nav>
      </div>
    </footer>
  );
};

export default MarketingFooter;
